exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  font-family: 'Roboto Slab', sans-serif;\n  font-weight: 300;\n  font-size: 20px;\n  margin-top: 25px;\n}\n\na {\n  color: white;\n}\n\na:hover {\n  color: #ffab40;\n  text-decoration: none;\n}\n\n.delete {\n  margin-left: 8px;\n  font-size: 22px;\n  color: \twhite;\n  font-family: 'Roboto', sans-serif;\n  font-weight: lighter;\n  opacity: .5;\n}\n\n.delete:hover {\n  opacity: .2;\n}\n\n.pencil {\n  margin-left: 20px;\n  width: 16px;\n  opacity: .5;\n}\n\n.pencil:hover {\n  opacity: .2;\n}\n\n.favoriteItem{\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: wrap row;\n          flex-flow: wrap row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Food-Savor/src/app/favorite-list/favorite-list.component.css
// module id = ../../../../../src/app/favorite-list/favorite-list.component.css
// module chunks = main